<div class="content-block library-teacher__paginate">
  <div class="flex flex-col items-center lg:justify-between lg:flex-row gap-1">
    <public-unit-type-selector (publicUnitTypeUpdatedEvent)="filterUpdated()" />
    <mat-paginator
      class="self-end"
      [hidePageSize]="true"
      [length]="filteredProjects.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageChange($event)"
    />
  </div>
  <div class="library__list flex flex-col flex-wrap items-start sm:flex-row">
    @for (project of filteredProjects; track project.id; let i = $index) {
      @if (isOnPage(i)) {
        <app-library-project [project]="project" class="w-full sm:w-1/2 lg:w-1/3" />
      }
    }
    @if (filteredProjects.length === 0) {
      <div class="notice" i18n>No units found.</div>
    }
  </div>
  <mat-paginator
    [length]="filteredProjects.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageChange($event, true)"
  />
</div>
